
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont les effets secondaires?`}</em></p>
    <p>{`Au printemps 2021, deux autres vaccins utilisant la technique du vecteur viral
(ceux d'AstraZeneca et de Johnson&Johnson) ont été au coeur d'une polémique
suite à quelques rares cas de thrombose. En avril, Moscou a assuré que son
produit, qui utilise la même technologie, n'a pas provoqué de tels effets
indésirables. L'institut Gamaleya a alors souligné que tous les vaccins basés
sur des vecteurs par adénovirus sont différents et ne peuvent être directement
comparés.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;